import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import directora from "../assets/nosotros/presentacion/directora.jpg";
import banner1 from "../assets/nosotros/presentacion/banner1.jpg";
import banner2 from "../assets/nosotros/presentacion/banner2.jpg";
import banner3 from "../assets/nosotros/presentacion/banner3.jpg";

import "./Presentacion.css";

const Presentacion = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="informacion-page">
      {/*  Banner superior */}
      <div className="info-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">¡Bienvenidos al Instituto de Educación Superior Tecnológico Público "Juan Velasco Alvarado"!</h1>
          <p className="lead">
            Instituto de Excelencia Tecnológica — Comprometidos con tu futuro profesional.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container py-5">
        

        {/*  Sección Director y mensaje institucional */}
        <div className="row align-items-center mt-5 presentacion-directora">
          <div className="col-lg-4 text-center" >
            <img
              src={directora}
              alt="Director Wildor Porfirio Javier Villafuerte"
              className="foto-directora"
            />
            <h5 className="mt-3 mb-0 fw-bold text-primary">
              Wildor Porfirio Javier Villafuerte
            </h5>
            <p className="text-muted">Dirección General</p>
          </div>

          <div className="col-lg-8" data-aos="fade-left">
            <h3 className="section-subtitle mb-3">
              Mensaje de la Dirección
            </h3>
            <div className="mensaje">
              <p>
                Es un honor dirigirme a ustedes como Director de esta institución que, durante
                33 años, ha brindado educación profesional técnica de calidad al servicio de
                nuestra sociedad. Nuestro Instituto fue creado para contribuir al crecimiento
                y competitividad del país, formando técnicos de primer nivel que respondan a las
                demandas del mercado laboral.
              </p>
              <p>
                Nos adaptamos continuamente a los avances en ciencia y tecnología, incorporándolos
                en nuestros procesos de enseñanza y aprendizaje. Ofrecemos modalidades educativas
                presenciales, utilizando herramientas digitales de vanguardia y un Diseño Curricular
                Básico Modular basado en competencias.
              </p>
              <p>
                La calidad educativa es nuestro principio fundamental. Contamos con un cuerpo docente
                altamente calificado y en constante actualización, asegurando que nuestros estudiantes
                reciban la mejor formación posible.Estamos comprometidos con la innovación y establecemos
                alianzas estratégicas con diversas instituciones para diseñar estrategias educativas que
                alineen nuestras enseñanzas con las demandas del sector productivo, siguiendo los
                lineamientos de la Ley de Institutos y Escuelas de Educación Superior.
                
              </p>
              <p>
                Cada vez más jóvenes optan por nuestra formación profesional técnica, y nos enorgullece 
                ser líderes en Lima Sur. Damos la más cordial bienvenida a nuestros futuros estudiantes, 
                deseándoles el mayor de los éxitos en su camino académico y profesional.
                Agradecemos su confianza en el Instituto de Educación Superior Tecnológico Público 
                “Juan Velasco Alvarado”. Estamos aquí para apoyarlos y guiarlos hacia un futuro prometedor.
              </p>
            </div>
          </div>
        </div>

        {/*  Banner inferior con 3 fotos */}
        <div className="banner-slider">
        <div className="slide-track">
          <img src={banner1} alt="Campus 1" />
          <img src={banner2} alt="Campus 2" />
          <img src={banner3} alt="Campus 3" />
       
          <img src={banner1} alt="Campus 1 duplicado" />
          <img src={banner2} alt="Campus 2 duplicado" />
          <img src={banner3} alt="Campus 3 duplicado" />
        </div>
      </div>


          {/*  Reseña Histórica */}
      <div className="timeline-section" data-aos="fade-up">
        <div className="container">
          <h2 className="text-center fw-bold mb-5 text-primary">Reseña Histórica</h2>

     


    <div className="timeline">

      <div className="timeline-item left" data-aos="fade-up">
        <div className="timeline-content">
          <h4>Década de 1980</h4>
          <p>
            Los pobladores de San Gabriel impulsaron la creación del Instituto,
            formando una comisión vecinal reconocida por Resolución de Alcaldía N° 355-89
            del 17 de abril de 1989, que gestionó la creación y construcción de su infraestructura.
          </p>
        </div>
      </div>

      <div className="timeline-item right" data-aos="fade-up">
        <div className="timeline-content">
          <h4>1992</h4>
          <p>
            Se autoriza el funcionamiento del Instituto mediante R.M. N° 172-92-ED con tres carreras:
            Contabilidad, Enfermería Técnica y Mecánica Automotriz. Las actividades iniciaron el
            5 de noviembre de 1992.
          </p>
        </div>
      </div>

      <div className="timeline-item left" data-aos="fade-up">
        <div className="timeline-content">
          <h4>1994</h4>
          <p>
            Se inaugura la actual infraestructura el 12 de julio de 1994, con la presencia del Presidente
            del Perú Ing. Alberto Fujimori y el Presidente de Colombia Lic. César Gaviria Trujillo.
          </p>
        </div>
      </div>

      <div className="timeline-item right" data-aos="fade-up">
        <div className="timeline-content">
          <h4>1996 - 1999</h4>
          <p>
            Se autoriza el turno diurno y nuevas carreras: Computación e Informática (R.D. 584-97-ED)
            y Técnica en Farmacia (R.D. 844-99-ED).
          </p>
        </div>
      </div>

      <div className="timeline-item left" data-aos="fade-up">
        <div className="timeline-content">
          <h4>2003</h4>
          <p>
            El Instituto alcanza más de 1000 alumnos y 27 secciones, consolidándose como
            una institución técnica líder en Lima Sur.
          </p>
        </div>
      </div>

      <div className="timeline-item right" data-aos="fade-up">
        <div className="timeline-content">
          <h4>2010 - 2011</h4>
          <p>
            La DRELM conforma una comisión reorganizadora y se implementa el nuevo
            Diseño Curricular Básico. Se modernizan las carreras profesionales.
          </p>
        </div>
      </div>

      <div className="timeline-item left" data-aos="fade-up">
        <div className="timeline-content">
          <h4>2012 - 2020</h4>
          <p>
            Bajo distintas gestiones directivas se fortalece la calidad educativa,
            modernizando los programas de estudio y la infraestructura institucional.
          </p>
        </div>
      </div>

      <div className="timeline-item right" data-aos="fade-up">
        <div className="timeline-content">
          <h4>2021 - Actualidad</h4>
          <p>
            Bajo la dirección de la Mg. Sandra Ore Calderón, el Instituto se encuentra rumbo
            al licenciamiento, con programas actualizados y alineados a estándares de calidad.
          </p>
        </div>
      </div>

    </div>
  </div>
</div>




             
      <div className="text-center mb-4">
        <a
          href="https://drive.google.com/file/d/1u7o1fzDlKwl2Dm8EuBQ93DtNQ7wZcJN2/view"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-descargar"
          data-aos="zoom-in"
        >
          📄 Ver Reseña Histórica
        </a>
      </div>

      </div>
    </section>
  );
};

export default Presentacion;
